<template>
  <div
    class="
      card card-plan
      shadow-sm
      bg-secondary
      text-center
      position-relative
    "
  >
    <div class="card__selection">
      <input type="checkbox" @change="handleCheck" />
      <div
        @click="handleFakeCheck"
        :class="
          model
            ? 'radio selection__custom radio--checked'
            : 'radio selection__custom'
        "
      ></div>
    </div>
    <div class="card__title m-3 text-center">
      <p class="text-dark fw-bold">
        <span style="color: #003b71 !important; font-size: 0.8rem !important">{{
          title
        }}</span>
      </p>
      <h3 style="color: #757575 !important; font-size: 0.8rem !important">
        {{ price }}
      </h3>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    price: String,
    pricesub: String,
    title: String,
    subtitle: String,
    value: String,
    model: Boolean,
    changePlan: Function,
    index: Number,
  },
  methods: {
    handleCheck(e) {
      this.removeChecks().then((_) => {
        const check = e.target;

        const customCheck =
          check.parentElement.querySelector(".selection__custom");

        if (!customCheck.classList.contains("radio--checked")) {
          customCheck.classList.add("radio--checked");
          check.checked = true;
          this.changePlan(this.index);
        }
      });
    },
    handleFakeCheck(e) {
      this.removeChecks().then((_) => {
        const fakeCheck = e.target.classList.contains("fa")
          ? e.target.parentElement
          : e.target;

        const input = fakeCheck.parentElement.querySelector("input");

        if (!fakeCheck.classList.contains("radio--checked")) {
          fakeCheck.classList.add("radio--checked");
          input.checked = true;
          this.changePlan(this.index);
        }
      });
    },
    getRoute(src) {
      if (!src) {
        return;
      }

      return src;
    },
    removeChecks() {
      return new Promise((resolve, _) => {
        const selectors = document.querySelectorAll(".selection__custom");
        selectors.forEach((selector, index) => {
          selector.classList.remove("radio--checked");

          if (index === selectors.length - 1) {
            resolve();
          }
        });
      });
    },
  },
  mounted() {},
};
</script>

<style lang="scss">
.card__image {
  width: 80px;
  height: 80px;
  img {
    max-height: 100%;
  }
}

@media (max-width: 767px) {
  .card__cobs {
    width: calc(33%) !important;
    margin-bottom: 10px;
  }
}
.card-plan {
  background-color: white !important;
  border-radius: 30px !important;

  .card__selection {
    input {
      position: absolute;
      right: 0;
      top: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
    }
  }
  .card__icon {
    font-size: 40px;
  }
  .card__title {
    h4 {
      font-size: 15px;
    }
  }
  .card__desc {
    p {
      font-size: 12px;
    }
  }
}

.radio {
  width: 20px;
  height: 20px;
  background-color: #f4f5f7;
  border: 1px solid gray;
  position: absolute;
  right: -5px;
  top: -5px;
  border-radius: 50%;

  .fa {
    display: none;
  }
}
.radio--checked {
  background-color: #00db23 !important;
  border: 1px solid #47bc1e !important;
  .fa {
    display: block !important;
    color: white;
    font-size: 14px;
    padding-top: 2px;
  }
}
</style>